import React from 'react';
import './styles.scss';

const Work: React.FC = () => {
    return (
        <div className="container gx-md-3 gx-sm-2 work-container">

            <section className="my-5 py-5">
                <h2 className="display-4 mb-4">Work Experience</h2>
                <div className="row">
                    <div className="col-md-8">
                        <div className="experience-item mb-5">
                            <h3 className="h4 fw-bold">Full Stack Developer — Disk Strata Contractor</h3>
                            <small className="text-muted d-block mb-3">May 2025 – Present — Spectra Logic (Remote)</small>
                            <ul className="experience-list">
                                <li>Contracted to build OSW-2400, a full-stack embedded web application for managing and monitoring SAS switch hardware in enterprise tape library environments.</li>
                                <li>Worked alongside three senior engineers during initial architecture and releases, then took over the entire codebase: frontend, backend, CI and testing infrastructure.</li>
                                <li>Built the full React / TypeScript frontend with Material UI, including real-time PHY monitoring, zoning configuration, and environment metrics dashboards.</li>
                                <li>Developed and extended Go server features including the REST API, WebSocket hub, background hardware polling, and licensing enforcement.</li>
                                <li>Built a simulator for hardware-free testing and established integration testing patterns across the core hardware communication layers.</li>
                                <li>Continued post-launch as sole developer, delivering bug fixes, new features, and training support team members on the system.</li>
                            </ul>
                        </div>

                        <div className="experience-item mb-5">
                            <h3 className="h4 fw-bold">Lead Innovation Engineer, Lead AI Developer, Full Stack Developer</h3>
                            <small className="text-muted d-block mb-3">August 2024 – Present — Pacer.co (Remote)</small>
                            <ul className="experience-list">
                                <li>Lead strategic AI-driven initiatives at an automotive software startup.</li>
                                <li>Managed graduate intern team to develop AI-powered applications using proprietary algorithms.</li>
                                <li>Built and deployed AI agents to automate vehicle evaluations for 15+ dealerships.</li>
                                <li>Designed and implemented full-stack applications using React (TypeScript) and Express (Node.js), deployed on Google Cloud.</li>
                                <li>Developed Selenium + Cron-based web crawler network aggregating millions of vehicle listings.</li>
                                <li>Engineered SOC2-compliant embedded script financing form for a 300+ dealership group.</li>
                            </ul>
                        </div>

                        <div className="experience-item mb-5">
                            <h3 className="h4 fw-bold">Trading Data Scientist and Developer (Quantitative Trading Analyst)</h3>
                            <small className="text-muted d-block mb-3">July 2022 – July 2024 — Columbia Threadneedle Investments (Boston, MA)</small>
                            <ul className="experience-list">
                                <li>Developed low-frequency trading tools for equity, fixed income, and FX traders, improving strategy execution.</li>
                                <li>Built an NLP-powered financial query assistant with entity recognition for investment data retrieval.</li>
                                <li>Analyzed portfolio manager trade timing behavior, identifying improvements worth millions in P&L.</li>
                                <li>Provided real-time intraday trading support using SQL and AWS for pre-trade analysis.</li>
                                <li>Passed CFA Level 1 exam (90th percentile).</li>
                            </ul>
                        </div>

                        <div className="experience-item mb-5">
                            <h3 className="h4 fw-bold">Quantitative Trading Analyst Co-op</h3>
                            <small className="text-muted d-block mb-3">January 2022 – June 2022 — Wellington Management Company (Boston, MA)</small>
                            <ul className="experience-list">
                                <li>Built an algorithmic portfolio rebalancing tool using Python’s DEAP library to reduce trade costs.</li>
                                <li>Analyzed trading cost outcomes across asset classes through full-stack coding projects.</li>
                                <li>Maintained internal reporting infrastructure to monitor quantitative strategies.</li>
                                <li>Gained deep knowledge of financial markets and trading strategies.</li>
                            </ul>
                        </div>

                        <div className="experience-item mb-5">
                            <h3 className="h4 fw-bold">Investment Analyst</h3>
                            <small className="text-muted d-block mb-3">September 2021 – December 2021 — NU Impact Investing (Boston, MA)</small>
                            <ul className="experience-list">
                                <li>Prospected and analyzed underfunded social enterprises in Boston.</li>
                                <li>Consulted closely with entrepreneurs to understand their business models and industry trends.</li>
                                <li>Conducted financial and impact-focused due diligence for $30,000 investment decisions.</li>
                                <li>Personally sourced and presented a leading investment candidate to board advisors.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Work;
